import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDevelopers = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 22,
	height: 19,
	viewBox: "0 0 22 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 1,
			y: 1.4668,
			width: 20,
			height: 16,
			rx: 4,
			stroke: "currentColor",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.45947 6.68863L4.52973 9.61837L7.45947 12.5481L6.57163 13.436L3.8147 10.679C3.22891 10.0932 3.22891 9.14349 3.8147 8.55771L6.57163 5.80078L7.45947 6.68863Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.0697 5.73424L9.93054 13.5028",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M14.5405 6.68863L17.4703 9.61837L14.5405 12.5481L15.4284 13.436L18.1853 10.679C18.7711 10.0932 18.7711 9.14349 18.1853 8.55771L15.4284 5.80078L14.5405 6.68863Z",
			fill: "currentColor"
		})
	]
});
export default SvgDevelopers;
